export interface OpcionEmpresa {
  value: string;
  label: string;
}

// ==================== INFORMACION DEL NEGOCIO ====================
// Los `value` son los que ya guarda el registro de empresa del dashboard en
// `data3`: cambiarlos rompería lo que compliance tiene registrado.

export const ORIGEN_FONDOS: OpcionEmpresa[] = [
  { value: 'Herencia', label: 'Herencia' },
  { value: 'Inversiones', label: 'Inversiones' },
  { value: 'Salario', label: 'Salario' },
  { value: 'Actividad productiva', label: 'Actividad productiva' },
  { value: 'Bienes raices', label: 'Bienes raíces' },
  { value: 'otros', label: 'Otros' },
];

export const INGRESOS_MENSUALES: OpcionEmpresa[] = [
  { value: 'Menor a 1,000 USD', label: 'Menor a 1.000 USD' },
  { value: 'Entre 1,000 y 3,000 USD', label: 'Entre 1.000 y 3.000 USD' },
  { value: 'Entre 3,000 y 5,000 USD', label: 'Entre 3.000 y 5.000 USD' },
  { value: 'Entre 5,000 y 10,000 USD', label: 'Entre 5.000 y 10.000 USD' },
  { value: 'Entre 10,000 y 20,000 USD', label: 'Entre 10.000 y 20.000 USD' },
  { value: 'Mayor a 20,000 USD', label: 'Mayor a 20.000 USD' },
];

// Misma escala para patrimonio total y financiero
export const PATRIMONIO: OpcionEmpresa[] = [
  { value: 'Menor a 10,000 USD', label: 'Menor a 10.000 USD' },
  { value: 'Entre 10,000 y 50,000 USD', label: 'Entre 10.000 y 50.000 USD' },
  { value: 'Entre 50,000 y 100,000 USD', label: 'Entre 50.000 y 100.000 USD' },
  { value: 'Entre 100,000 y 500,000 USD', label: 'Entre 100.000 y 500.000 USD' },
  { value: 'Mayor a 500,000 USD', label: 'Mayor a 500.000 USD' },
];

export const ACTIVIDADES_ECONOMICAS: OpcionEmpresa[] = [
  {
    value: 'software',
    label: 'Venta al por mayor de equipo, partes y piezas electrónico y de telecomunicaciones',
  },
  {
    value: 'comercio',
    label: 'Otras actividades de venta al por menor en comercios no especializados',
  },
  {
    value: 'servicios',
    label: 'Otras actividades auxiliares de servicios financieros',
  },
  { value: 'otros', label: 'Otros' },
];

export const CANTIDAD_OPERACIONES: OpcionEmpresa[] = [
  { value: 'Menos de 50', label: 'Menos de 50' },
  { value: 'Entre 50 y 100', label: 'Entre 50 y 100' },
  { value: 'Entre 100 y 500', label: 'Entre 100 y 500' },
  { value: 'Mas de 500', label: 'Más de 500' },
];

/**
 * Funciones PEP del formulario de empresa.
 *
 * Es la misma lista que usa hoy el registro de empresa del dashboard, mantenida
 * aparte de PEP_CARGOS (flujo de persona) porque los valores se guardan tal cual
 * en `data1` y cambiarlos rompería lo que compliance ya tiene registrado.
 */
export const PEP_FUNCIONES: string[] = [
  'Presidente de la República',
  'Senadores, diputados y alcaldes',
  'Ministros de la Corte Suprema y Cortes de Apelaciones',
  'Ministros de Estado',
  'Subsecretarios',
  'Intendentes',
  'Gobernadores',
  'Secretarios Regionales Ministeriales',
  'Embajadores',
  'Jefes superiores de servicio (centralizados y descentralizados)',
  'Comandantes en Jefe de las Fuerzas Armadas',
  'Director General de Carabineros',
  'Director General de Investigaciones',
  'Fiscales Regionales',
  'Contralor General de la República',
  'Consejeros del Banco Central de Chile',
  'Otros',
];
